module.exports = __webpack_public_path__ + "static/media/BannerWithImage@1x.d7f0961e628e4f088164cc3c63d34bf4.jpg";